import { useSelector } from "react-redux";
import type { RootState } from "../../../app/store";
import { Toast } from "./Toast";

export const ToastContainer = () => {
	const toasts = useSelector((state: RootState) => state.toast.toasts);

	if (toasts.length === 0) return null;

	return (
		<section
			aria-label="Notifications"
			className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-3 items-end"
		>
			{toasts.map((toast) => (
				<Toast key={toast.id} toast={toast} />
			))}
		</section>
	);
};
